<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch00_fm05"></a><a id="page_v"><img alt="images" src="images/f000v-01.jpg"/> <strong>Contents</strong></a></h2><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a class="nounder" href="#/xhtml/ch01#ch01">Chapter 1: New York, New York, It’s a Wonderful Town</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Chapter 2: An Ugly Accusation</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3: SoHo Time-Out</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4: Vanishing Act</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Chapter 5: Hunting for Clues</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6: Breaking and Entering</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7: Trapped!</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Chapter 8: The Wrong Answers</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Chapter 9: Makeover on the Move</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Chapter 10: The Frog Connection</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Chapter 11: Closing In on the Truth</span></p>
<p class="toc1"><a id="page_vi"></a><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Chapter 12: Satrap!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?4e5df53a